import React, { useEffect, useState } from "react";
import TauriSimpleBreadcrumbs from "../../TauriSimpleBreadcrumbs/TauriSimpleBreadcrumbs";
import './TauriItemCard.css'

const TauriItemCard = ({ item, onClick }) => {
    const Access_Type = [
        { type: "customers", value: 8 },
        { type: "agents", value: 1 },
        { type: "districts", value: 2 },
        { type: "district", value: 2 },
        { type: "territories", value: 1 },
        { type: "dm", value: 2 },
        { type: "distributors", value: 3 },
        { type: "regions", value: 4 },
        { type: "region", value: 4 },
        { type: "items", value: 10 },
    ];

    const [accessType, setAccessType] = useState(null);

    const extractCode = (text) => {
        const parts = text.split('-');
        return parts.length > 1 ? parts.slice(1).join('-') : text;
    };

    const extractCodeEmployee = (text) => {
        const parts = text.split('|');
        return parts.length > 1 ? parts.slice(1).join('|') : text;
    };

    useEffect(() => {
        if (item) {
            const url = new URL(item.access_path, window.location.origin);
            const pathParts = url.pathname.split('/').filter(Boolean);
            const accesstype = pathParts[pathParts.length - 1];
            const accessDetails = Access_Type.find(item => item.type === accesstype);
            setAccessType(accessDetails?.value || -1);
        }
    }, [item]);

    return (
        <div className="tauri-item-card" onClick={onClick}>
            <img src={process.env.PUBLIC_URL + "/Images/mdi--user-circle.svg"} className="item-card-image" alt="Icon"/>
            <div className="item-card-content">
                <div className="item-card-header">
                    <div className="item-header-code me-1">
                        {
                            accessType === 8 ? extractCode(item.identifier)
                                : accessType === 1 ? extractCodeEmployee(item.identifier)
                                    : item.identifier
                        }
                    </div>
                    <div className="item-header-title">
                        {item.header}
                    </div>
                </div>
                <div className="item-card-path">
                    <TauriSimpleBreadcrumbs path={item.displayed_path} />
                </div>
            </div>
        </div>
    );
};

export default TauriItemCard